import script from "./NotificationList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationList.vue?vue&type=script&setup=true&lang=js"

import "./NotificationList.vue?vue&type=style&index=0&id=7590ed04&scoped=true&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7590ed04"]])

export default __exports__